import { Condition as ModelCondition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type OrderCountGreaterThanState = string;

export const ORDER_COUNT_GREATER_THAN = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<OrderCountGreaterThanState>
  >,
): ConditionType<
  OrderCountGreaterThanState,
  ModelCondition.OrderCountGreaterThan
> => ({
  name: "Order count greater than",
  description(state) {
    return `More than ${+state} orders`;
  },
  Details(props: ConditionTypeDetailsProps<OrderCountGreaterThanState>) {
    return React.createElement(Details, props);
  },
  empty: String(0),
  fromModel(model) {
    return model.orderCount;
  },
  toModel(state) {
    return { type: ModelCondition.ORDER_COUNT_GREATER_THAN, orderCount: state };
  },
  valid(state) {
    return state !== undefined;
  },
});
